import { createEmptyListingAttributes } from '../config/listingAttributesModel';

/**
 * True if stay satisfies all non-empty secondary filter selections.
 * Uses `stay.listingAttributes` when present; legacy stays without it fail only when a filter is set (strict).
 */
export function stayMatchesSecondaryFilters(stay, secondary) {
  if (!secondary) return true;
  const la = {
    ...createEmptyListingAttributes(),
    ...(stay.listingAttributes && typeof stay.listingAttributes === 'object' ? stay.listingAttributes : {})
  };

  for (const [key, filterVal] of Object.entries(secondary)) {
    if (filterVal == null || filterVal === '') continue;
    if (Array.isArray(filterVal) && filterVal.length === 0) continue;
    if (key === 'distanceFromCityKm' && (filterVal === 0 || filterVal === null)) continue;

    const stayVal = la[key];

    if (key === 'powerBackup' && (filterVal === 'Yes' || filterVal === 'No')) {
      const hasBackup = stayVal === 'Yes' || stayVal === 'Inverter' || stayVal === 'Generator';
      if (filterVal === 'Yes' && !hasBackup) return false;
      if (filterVal === 'No' && hasBackup) return false;
      continue;
    }

    if (filterVal === 'Yes' || filterVal === 'No') {
      if (stayVal !== filterVal) return false;
      continue;
    }

    if (Array.isArray(filterVal)) {
      const s = Array.isArray(stayVal) ? stayVal : [];
      const ok = filterVal.every((f) => s.includes(f));
      if (!ok) return false;
      continue;
    }

    if (key === 'bedroomsCount' || key === 'bathroomsCount' || key === 'distanceFromCityKm') {
      const need = typeof filterVal === 'number' ? filterVal : Number(filterVal);
      if (Number.isNaN(need)) continue;
      const have = stayVal != null ? Number(stayVal) : null;
      if (have == null || Number.isNaN(have)) return false;
      if (key === 'distanceFromCityKm') {
        if (have > need) return false;
      } else {
        if (have < need) return false;
      }
      continue;
    }

    if (typeof filterVal === 'string') {
      if (stayVal !== filterVal) return false;
    }
  }

  return true;
}

export function hasActiveSecondaryFilters(secondary) {
  if (!secondary) return false;
  return Object.entries(secondary).some(([k, v]) => {
    if (v == null || v === '') return false;
    if (Array.isArray(v) && v.length === 0) return false;
    if (k === 'distanceFromCityKm' && v === 0) return false;
    return true;
  });
}
